import { UserService } from '@api/services/user.service';
import { type UserCompany } from '@api/models';
import { Component, inject, type OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@infra/auth/auth.service';
import { SecurityService } from '@infra/auth/security.service';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-user-company-selector',
  templateUrl: './user-company-selector.component.html',
  imports: [SelectModule, FormsModule, TranslatePipe],
})
export class CompanySelectorComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);
  private readonly securityService = inject(SecurityService);

  companies: UserCompany[] = [];
  selectedCompany?: UserCompany;

  ngOnInit(): void {
    this.userService.getUserCompanies().subscribe(companies => {
      this.companies = companies;
      this.selectedCompany = this.companies.find(x => x.id === this.authService.companyId);
    });
  }

  changeCompany(): void {
    if (this.selectedCompany?.url) {
      this.securityService.getNewToken(this.selectedCompany.url).subscribe(response => {
        this.authService.setLoggedIn(response.authToken);
        void this.router.navigate(['/company', this.selectedCompany.url]).then(() => {
          window.location.reload();
        });
      });
    }
  }
}
